import { ApiClient } from '../client'

export class AnalyticsApi {
  constructor(private client: ApiClient) {}

  async getDashboardStats(): Promise<{
    total_campaigns: number
    active_campaigns: number
    total_users: number
    total_organisations: number
    recent_activity: Array<{
      type: string
      description: string
      timestamp: string
    }>
  }> {
    const response = await this.client.get<any>('/v1/analytics/dashboard')
    return response?.data || response
  }

  async getCampaignAnalytics(campaignId: string): Promise<{
    open_rate: number
    click_rate: number
    credential_rate: number
    time_to_click_avg: number
    by_hour: Record<string, number>
    by_target: Array<{
      email: string
      opened: boolean
      clicked: boolean
      time_to_click?: number
    }>
  }> {
    return this.client.get<any>(`/v1/analytics/campaigns/${campaignId}`)
  }

  async getOrganisationAnalytics(orgId: string, params: {
    start_date?: string
    end_date?: string
  } = {}): Promise<{
    campaigns_run: number
    average_click_rate: number
    average_credential_rate: number
    improvement_trend: number
    risk_score: number
  }> {
    return this.client.get<any>(`/v1/analytics/organisations/${orgId}`, params)
  }

  async getCustomerAnalytics(params: {
    start_date?: string
    end_date?: string
  } = {}): Promise<{
    total_campaigns: number
    total_emails_sent: number
    overall_click_rate: number
    overall_credential_rate: number
    by_organisation: Array<{
      organisation_id: string
      organisation_name: string
      campaigns: number
      click_rate: number
    }>
    by_month: Record<string, {
      campaigns: number
      emails_sent: number
      clicks: number
    }>
  }> {
    return this.client.get<any>('/v1/analytics/customer', params)
  }

  async exportReport(type: 'campaign' | 'organisation' | 'customer', id: string, format: 'pdf' | 'csv' | 'excel'): Promise<{
    download_url: string
    expires_at: string
  }> {
    return this.client.post<any>(`/v1/analytics/export`, {
      type,
      id,
      format
    })
  }

  // Admin statistics
  async getAdminStats(): Promise<{
    total_customers: number
    active_customers: number
    total_revenue: number
    campaigns_this_month: number
    growth_rate: number
  }> {
    const response = await this.client.get<any>('/admin/statistics')
    return response?.data || response
  }
}
